export { CloseOutlined } from '@ant-design/icons-vue'

export const CloseIconClass =
  'absolute top-[16px] right-[16px] text-14 text-font-40 hover:text-primary'

export const CloseIconOutClass =
  'absolute top-[0px] right-[-35px] text-16 text-white w-[30px] h-[30px] flex-y-center justify-center rounded-full hover:bg-[rgba(255,255,255,0.2)]'
